import { ApiClient } from '../api-client';

const OfferApi = ApiClient.service.offer;
/**
 *  useOfferApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */

const useOfferApi = () => {
  return OfferApi;
};

export { OfferApi, useOfferApi };
